import {GoogleTagManagerService} from "angular-google-tag-manager";
import {ViewItemDataCarrier} from "../interface/carrier/view-item-data-carrier";
import {SelectItemDataCarrier} from "../interface/carrier/select-item-data-carrier";

export abstract class GTMEvent {

	protected constructor(
		private _gtm: GoogleTagManagerService
	) {}

	public clearDataLayer(): void {
		this._gtm.pushTag({
			ecommerce: null
		}).then();
	}

	public abstract push(data: ViewItemDataCarrier | SelectItemDataCarrier): void;
}
